// extracted by mini-css-extract-plugin
module.exports = {"ArtInfo":"ArtInfo_ArtInfo__1e0Vl","title":"ArtInfo_title__1UTLb","text":"ArtInfo_text___P1xl"};